import React from 'react';
import ServicePage from './ServicePage';

export default function GreenlineKitchens() {
  return (
    <ServicePage
      category="kitchen"
      eyebrow="01 · Kitchens"
      title={<>Heirloom <em className="not-italic" style={{ color: 'var(--gl-primary)' }}>kitchens.</em></>}
      intro="The kitchen is the part of the house that gets used the hardest and judged the closest. We build them to outlive the trend cycle."
      description="Custom inset cabinetry, integrated paneled appliances, slab-vein matched countertops, and joinery details that hold up to wet hands and stainless pans for thirty years. We work in tight Boston brownstones, sprawling suburban L-shapes, and everything in between. Every kitchen begins with a sit-down at your existing table — we want to see how you actually live before we draw a line."
    />
  );
}
